<template>
  <div class="detailPage">
    <div class="content line">
      <div class="order_info">
        <p>退款工单号：{{ dataItem.workno }}</p>
        <p>订单号：{{ dataItem.orderno }}</p>
        <p>创建时间：{{ dataItem.createdate | formatDate }}</p>
        <p>销售专员姓名：{{ dataItem.saler_note }}</p>
      </div>
      <div
        class="block"
        v-for="(item, index) in dataItem.ams_shop_backlog_detail"
        :key="index"
      >
        <h1>商品名称：{{ item.commodityname }}</h1>
        <!-- <h1>
          商品ID：<span>{{ item.id }}</span>
        </h1> -->
        <h1>
          商品SKU：<span>{{ item.sku }}</span>
        </h1>
        <h1 v-if="item.cbprice">
          成本参考价：<span>¥ {{ item.cbprice }}/件</span>
        </h1>
        <h1 v-if="item.price">
          基础零售价：<span>¥ {{ item.price }}/件</span>
        </h1>
        <h1 v-if="item.pfprice">
          批发参考价：<span>¥ {{ item.pfprice }}/件</span>
        </h1>
        <h1 v-if="item.groupprice">
          基础批发价：<span>¥ {{ item.groupprice }}/件</span>
        </h1>
        <h1>
          <p v-for="(label, labelIndex) in item.attr" :key="labelIndex">
            <span>{{ label }}</span
            ><span>：{{ item.attrPrice }}/件</span>
          </p>
        </h1>
        <h1>
          商品数量：<span>{{ item.num }}</span>
        </h1>
        <h1>
          价格小计：<span>{{ item.newPrice }}</span>
        </h1>
      </div>
    </div>
    <div class="content line">
      <div class="address_wrap">
        <div class="item flex-rowl">
          <p>账户姓名：</p>
          <p>{{ dataItem.truename }}</p>
        </div>
        
        <!-- <div class="item flex-rowl">
          <p>账户id：</p>
          <p>{{ dataItem.accountid }}</p>
        </div>
        <div class="item flex-rowl">
          <p>用户手机号：</p>
          <p>{{ dataItem.mobile }}</p>
        </div> -->
        <div class="item flex-rowl">
          <p>物流类型：</p>
          <p>{{ dataItem.service_companystr }}</p>
        </div>
        <div class="item flex-rowl">
          <p>发货物流单号：</p>
          <p>{{ dataItem.service_no ? dataItem.service_no : '暂无' }}</p>
        </div>
        <!-- <div class="item flex-rowl">
          <p>是否取消退款：</p>
          <p>{{ dataItem.iscancel == 1 ? "是" : "否" }}</p>
        </div> -->
        <div class="item flex-rowl">
          <p>退款属性：</p>
          <p>{{ dataItem.returnattrstr }}</p>
        </div>
        <div class="item flex-rowl">
          <p>备注信息：</p>
          <p>{{ dataItem.talk }}</p>
        </div>
      </div>
    </div>
    <div class="content line">
      <div class="address_wrap">
        <div class="item flex-rowl">
          <p>退款类型：</p>
          <p>{{ dataItem.logtypestr }}</p>
        </div>
        <div class="item flex-rowl">
          <p>退款金额：</p>
          <p>{{ dataItem.fee }}</p>
        </div>
        <div class="item flex-rowl">
          <p>退款情况：</p>
          <p>{{ dataItem.returnnotestr }}</p>
        </div>
         
        <div class="item flex-rowl">
          <p>退费原因：</p>
          <p>{{ dataItem.reasonidstr }}</p>
        </div>
        <div class="item flex-rowl">
          <p>退款状态：</p>
          <p>{{ dataItem.returnstate }}</p>
        </div>
        <div class="item flex-rowl">
          <p>退款审核状态：</p>
          <p>
            {{
              dataItem.checkstatestr}}
          </p>
        </div>
       
        <div class="item flex-rowl">
          <p>退款时间：</p>
          <p>{{ dataItem.returndate | formatDate }}</p>
        </div>
      </div>
    </div>

    <!-- 底部操作 -->
    <div class="fixd_button_btm flex-between" v-if="isShowTabbar">
      <div class="item" :class="{'disabled': dataItem.checkstate == 4 || dataItem.checkstate == 5 }" @click="handleEdit">审批操作</div>
      <div class="item" @click="handleReturn">返回</div>
    </div>
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getBacklogDetail } from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "cBacklogDetail",
  data() {
    return {
      isShowTabbar: true,
      qyid: "",
      dataItem: "",
      id: ''
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id
        this.getBacklogDetail(id);
      } else {
        this.$router.back();
      }
    },
    // 订单列表
    getBacklogDetail(id) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getBacklogDetail({ id }).then((res) => {
        if (res.ams_shop_backlog_detail.length > 0) {
          res.ams_shop_backlog_detail.forEach((v1) => {
            v1.attr = JSON.parse(v1.attr);
            // 单件商品总价 (零售价 +/- 标签价) * 数量  后续加入折扣价针对于第一个商品
            let attrPrice =
              v1.attrnumtype == "不变"
                ? 0
                : v1.attrnumtype == "减少"
                ? "-" + v1.attrnum
                : v1.attrnum;

            v1.attrPrice =
              v1.attrnumtype == "不变"
                ? "¥" + 0
                : v1.attrnumtype == "减少"
                ? "- ¥" + v1.attrnum
                : "+ ¥" + v1.attrnum;
            v1.newPrice = calculator(calculator(v1.price).add(attrPrice))
              .multiply(v1.num)
              .toNumber();
          });
        }
        this.dataItem = res;
        Toast.clear();
      });
    },

    handleReturn() {
      this.$router.back();
    },

    handleToast() {
      this.$toast("即将开放");
    },

    // 计算商品差价
    shopPriceDifference(price, price1) {
      return calculator(price1).subtract(price).toNumber();
    },

    handleEdit() {
      let {dataItem} = this
      if(dataItem.checkstate == 4 || dataItem.checkstate == 5) {
        return
      }
      this.encryptstringadd("cBacklogEdit", { id: this.id});
    },

      // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: '',
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.detailPage {
  padding-bottom: 300px;
  .line {
    border-bottom: 9px solid #f5f5f5;
  }
  .content {
    padding: 39px 42px 47px;
    .order_info {
      font-size: 22px;
      color: #3c3c3c;
      margin-bottom: 25px;
      p {
        &:nth-child(2) {
          margin: 15px 0;
        }
      }
    }
    .block {
      margin-bottom: 50px;
      &:last-child {
        margin-bottom: 0;
      }
      h1 {
        font-size: 20px;
        color: #3c3c3c;
        margin-bottom: 9px;
      }
      .txt {
        margin-bottom: 19px;
        p {
          font-size: 18px;
          color: #969696;
          line-height: 30px;
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .price {
      font-size: 24px;
      p {
        &:last-child {
          font-size: 40px;
          span {
            font-size: 24px;
            margin-right: 10px;
          }
        }
      }
    }
    .price_btm {
      margin-top: 50px;
      font-size: 24px;
      p {
        &:last-child {
          font-size: 20px;
          span {
            font-size: 22px;
          }
        }
      }
    }
    .price_other {
      font-size: 24px;
      span {
        font-size: 24px;
        margin-right: 22px;
      }
      .txt {
        margin: 77px 0 50px;
        .red {
          font-size: 40px;
          color: #ee0032;
        }
      }
      .txt1 {
        p {
          &:last-child {
            font-size: 40px;
          }
        }
      }
      .detail_btn {
        height: 40px;
        line-height: 40px;
        margin: 0;
        padding: 0 20px;
        font-size: 18px;
        border: 1px solid #aaaaaa;
        display: inline-block;
        border-radius: 22px;
        margin-top: 29px;
      }
    }
  }
  .address_wrap {
    font-size: 22px;
    .item {
      margin-bottom: 30px;
      align-items: flex-start;
      p {
        &:first-child {
          white-space: nowrap;
          width: 190px;
        }
      }
    }
    .txt {
      font-size: 20px;
      line-height: 30px;
    }
  }
  .pay_wrap {
    padding: 42px 57px 150px;
    font-size: 24px;
    box-sizing: border-box;
    .tit {
      margin-bottom: 70px;
    }
    .block {
      font-size: 22px;
      color: #aaaaaa;
      margin-bottom: 59px;
      padding-left: 39px;
      p {
        margin-bottom: 35px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .mark {
      font-size: 22px;
      padding-left: 39px;
      p {
        color: #aaaaaa;
        margin-top: 28px;
      }
    }
  }
  .status_wrap {
    padding: 55px 58px 0;
    font-size: 22px;
    color: #3c3c3c;
    .red {
      font-size: 30px;
      color: #ee0032;
    }
    .block {
      margin-bottom: 110px;
    }
    .txt1 {
      margin-bottom: 25px;
    }
  }
  .goods-bottom-operation {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #ffffff;
    box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.04);
    box-sizing: border-box;
    font-size: 24px;
    color: #000000;
    padding: 50px 73px 115px 46px;
    .arr {
      transform: rotate(90deg);
      .iconfont {
        font-size: 40px;
      }
    }
  }
  .fixd_button_btm {
    .item {
      &.disabled {
        color: #aaaaaa;
      }
    }
  }
}
</style>